// 系統版本號 - 每次更新時預期遞增
export const SYSTEM_VERSION = "1.37.33";

// 鷹幣與鷹鑽圖示
export const EAGLE_COIN_ICON = "https://files.manuscdn.com/user_upload_by_module/session_file/310419663029099456/lFLOYISKscoKuNco.png";
export const EAGLE_DIAMOND_ICON = "https://files.manuscdn.com/user_upload_by_module/session_file/310419663029099456/bdaFpSIpyZMJzfgY.png";

// 商城配件類型圖示
export const SHOP_TYPE_ICONS: Record<string, string> = {
  avatar_frame: "https://files.manuscdn.com/user_upload_by_module/session_file/310419663029099456/bjXSgmLGmVVpkvRY.png",
  title: "https://files.manuscdn.com/user_upload_by_module/session_file/310419663029099456/hJqGJNwKMNhcxUbv.png",
  badge_style: "https://files.manuscdn.com/user_upload_by_module/session_file/310419663029099456/BYpvoHMTeoZojfRd.png",
  theme_skin: "https://files.manuscdn.com/user_upload_by_module/session_file/310419663029099456/tfbIteDJyeWMQdIp.png",
  special_effect: "https://files.manuscdn.com/user_upload_by_module/session_file/310419663029099456/KTvMgqsioQqIBsJJ.png",
};

// 誠鷹集團旗下公司列表

export const COMPANIES = [
  { id: 0, code: "CYGROUP", name: "誠鷹集團", shortName: "誠鷹集團" },
  { id: 1, code: "CYSG", name: "誠鷹特勤保全股份有限公司", shortName: "誠鷹保全" },
  // id: 2700001 為舊版重複資料，已停用，統一使用 id: 1
  { id: 2, code: "CYPM", name: "誠鷹公寓大廈管理維護有限公司", shortName: "誠鷹公寓" },
  { id: 3, code: "XRSG", name: "芯榕特勤保全股份有限公司", shortName: "芯榕保全" },
  { id: 4, code: "XRPM", name: "芯榕公寓大廈管理維護有限公司", shortName: "芯榕公寓" },
  { id: 5, code: "OKMC", name: "歐凱利管理顧問有限公司", shortName: "歐凱利" },
  { id: 6, code: "CYENT", name: "誠鷹企業社", shortName: "誠鷹企業社" },
  { id: 7, code: "CYAUD", name: "誠鷹集團稽核室", shortName: "稽核室" },
] as const;

// 公司 Logo 對應表
export const COMPANY_LOGOS: Record<string, string> = {
  // 誠鷹集團
  "CYGROUP": "/chengying-logo.png",
  // 誠鷹特勤保全 & 誠鷹公寓 使用同一個 Logo
  "CYSG": "/company-logo-chengying.jpg",
  "CYPM": "/company-logo-chengying.jpg",
  // 芯榕特勤保全 & 芯榕公寓 使用同一個 Logo
  "XRSG": "/company-logo-xinrong.jpg",
  "XRPM": "/company-logo-xinrong.jpg",
  // 歐凱利管理顧問
  "OKMC": "/company-logo-okali.png",
  // 誠鷹企業社
  "CYENT": "/company-logo-chengying-enterprise.png",
  // 誠鷹集團稽核室
  "CYAUD": "/chengying-logo.png",
};

// 根據公司 ID 取得 Logo
export function getCompanyLogo(companyId: number | null | undefined): string {
  if (!companyId) return "/chengying-logo.png"; // 預設誠鷹集團 Logo
  const company = COMPANIES.find(c => c.id === companyId);
  if (!company) return "/chengying-logo.png";
  return COMPANY_LOGOS[company.code] || "/chengying-logo.png";
}

// 根據公司代碼取得 Logo
export function getCompanyLogoByCode(companyCode: string | null | undefined): string {
  if (!companyCode) return "/chengying-logo.png";
  return COMPANY_LOGOS[companyCode] || "/chengying-logo.png";
}

// 系統功能權限定義
export const PERMISSIONS = [
  { key: "dashboard", label: "儀表板", description: "查看系統總覽與統計資料" },
  { key: "organization", label: "組織管理", description: "管理公司與部門架構" },
  { key: "personnel", label: "人事管理", description: "管理員工資料與考勤" },
  { key: "sites", label: "案場管理", description: "管理案場與合約" },
  { key: "documents", label: "文件管理", description: "上傳與管理文件" },
  { key: "training", label: "教育訓練", description: "管理訓練課程與記錄" },
  { key: "attendance", label: "考勤管理", description: "查看與管理考勤記錄" },
  { key: "leave", label: "請假管理", description: "申請與審核請假" },
  { key: "certificates", label: "證照管理", description: "管理員工證照" },
  { key: "contracts", label: "合約管理", description: "管理案場合約" },
  { key: "reports", label: "報表查詢", description: "查看各類統計報表" },
  { key: "users", label: "使用者管理", description: "管理系統使用者" },
  { key: "audit", label: "稽核日誌", description: "查看系統操作記錄" },
  { key: "settings", label: "系統設定", description: "管理系統設定" },
] as const;

// 角色定義
export const ROLES = [
  { key: "superadmin", label: "最高管理員", description: "擁有所有權限" },
  { key: "admin", label: "管理員", description: "管理所有公司資料" },
  { key: "manager", label: "主管", description: "管理所屬公司資料" },
  { key: "employee", label: "一般員工", description: "基本功能存取" },
] as const;

// 案場狀態
export const SITE_STATUS = [
  { key: "active", label: "服務中", color: "success" },
  { key: "terminated", label: "已解約", color: "muted" },
] as const;

// 案場類型
export const SITE_TYPES = [
  { key: "residential", label: "住宅大樓" },
  { key: "commercial", label: "商業大樓" },
  { key: "industrial", label: "工業廠房" },
  { key: "government", label: "政府機關" },
  { key: "other", label: "其他" },
] as const;

// 員工狀態
export const EMPLOYEE_STATUS = [
  { key: "active", label: "在職", color: "success" },
  { key: "probation", label: "試用期", color: "warning" },
  { key: "suspended", label: "停職", color: "error" },
  { key: "resigned", label: "離職", color: "muted" },
] as const;

// 請假類型
export const LEAVE_TYPES = [
  { key: "annual", label: "特休假" },
  { key: "sick", label: "病假" },
  { key: "personal", label: "事假" },
  { key: "marriage", label: "婚假" },
  { key: "maternity", label: "產假" },
  { key: "paternity", label: "陪產假" },
  { key: "funeral", label: "喪假" },
  { key: "official", label: "公假" },
  { key: "other", label: "其他" },
] as const;

// 訓練課程類別
export const TRAINING_CATEGORIES = [
  { key: "mandatory", label: "必修課程" },
  { key: "professional", label: "專業課程" },
  { key: "safety", label: "安全訓練" },
  { key: "management", label: "管理課程" },
  { key: "other", label: "其他" },
] as const;

// 文件存取層級
export const DOCUMENT_ACCESS_LEVELS = [
  { key: "public", label: "公開", description: "所有人可查看" },
  { key: "company", label: "公司內部", description: "同公司人員可查看" },
  { key: "department", label: "部門內部", description: "同部門人員可查看" },
  { key: "private", label: "私人", description: "僅本人可查看" },
] as const;

// 證照類型
export const CERTIFICATE_TYPES = [
  { key: "license", label: "執照" },
  { key: "certificate", label: "證書" },
  { key: "qualification", label: "資格證" },
  { key: "permit", label: "許可證" },
  { key: "other", label: "其他" },
] as const;

// 班別類型
export const SHIFT_TYPES = [
  { key: "day", label: "日班" },
  { key: "night", label: "夜班" },
  { key: "rotating", label: "輪班" },
  { key: "flexible", label: "彈性" },
] as const;


// 案場職位類型
export const SITE_POSITION_TYPES = [
  { key: "director", label: "總幹事" },
  { key: "deputy_director", label: "副總幹事" },
  { key: "finance_secretary", label: "財務秘書" },
  { key: "admin_secretary", label: "行政秘書" },
  { key: "bar_secretary", label: "吧檯秘書" },
  { key: "security", label: "保全" },
  { key: "cleaning_staff", label: "清潔人員" },
  { key: "other", label: "其他" },
] as const;

export type SitePositionType = typeof SITE_POSITION_TYPES[number]["key"];

// 員工職位類型（公司內部職位）
export const EMPLOYEE_POSITIONS = [
  { key: "president", label: "總裁", level: 1, salaryRange: { min: 200000, max: 500000 } },
  { key: "chairman", label: "董事長", level: 2, salaryRange: { min: 180000, max: 400000 } },
  { key: "general_manager", label: "總經理", level: 3, salaryRange: { min: 150000, max: 300000 } },
  { key: "deputy_general_manager", label: "副總經理", level: 4, salaryRange: { min: 120000, max: 250000 } },
  { key: "ceo", label: "執行長", level: 5, salaryRange: { min: 100000, max: 200000 } },
  { key: "associate_manager", label: "協理", level: 6, salaryRange: { min: 80000, max: 150000 } },
  { key: "manager", label: "經理", level: 7, salaryRange: { min: 60000, max: 120000 } },
  { key: "deputy_manager", label: "副理", level: 8, salaryRange: { min: 50000, max: 100000 } },
  { key: "director", label: "處長", level: 9, salaryRange: { min: 45000, max: 90000 } },
  { key: "team_leader", label: "組長", level: 10, salaryRange: { min: 40000, max: 70000 } },
  { key: "general_secretary", label: "總幹事", level: 11, salaryRange: { min: 35000, max: 60000 } },
  { key: "secretary", label: "秘書", level: 12, salaryRange: { min: 30000, max: 50000 } },
  { key: "security", label: "保全人員", level: 13, salaryRange: { min: 28000, max: 45000 } },
  { key: "other", label: "其他", level: 99, salaryRange: { min: 27470, max: 60000 } },
] as const;

export type EmployeePositionKey = typeof EMPLOYEE_POSITIONS[number]["key"];

// 根據職位取得薪資級距
export function getSalaryRangeByPosition(positionKey: string): { min: number; max: number } | null {
  const position = EMPLOYEE_POSITIONS.find(p => p.key === positionKey);
  return position ? position.salaryRange : null;
}

// 根據職位標籤取得職位 key
export function getPositionKeyByLabel(label: string): string | null {
  const position = EMPLOYEE_POSITIONS.find(p => p.label === label);
  return position ? position.key : null;
}
